module.exports = __webpack_public_path__ + "f249336227bb51a712c390099983c6a9.svg";